import { intervalToDuration } from 'date-fns/intervalToDuration';

export default function getTimeRemaining(remainingSeconds?: number | null): string {
  if (remainingSeconds == null) {
    return '';
  }
  const { minutes = 0, seconds = 0 } = intervalToDuration({
    start: 0,
    end: remainingSeconds * 1000,
  });

  return `${minutes.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}:${seconds.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}`;
}
